import { useEffect, useState } from "react";
import api from "../Api/api";
import Client from "../Types/Client";
import { Typography, Box } from "@mui/material";

const getConnectedClients = async () => {
  return await api.getConnectedClients();
};

const ConnectedClient = (data: Client) => (
  <Typography variant="h6" component="div">
    {data.name}
  </Typography>
);

export default function ConnectedClientsList() {
  const [clients, setClients] = useState<Client[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const connectedClients = await getConnectedClients();
      setClients(connectedClients);
    };
    fetchData();
  }, []);

  return (
    <Box className="container__card" sx={{ boxShadow: 2 }}>
      {clients.length > 0 && (
        <>
          <Typography
            variant="h3"
            component="div"
            className="container__header"
          >
            Connected Clients
          </Typography>
          {clients.map((client) => (
            <ConnectedClient {...client} key={client.id} />
          ))}
        </>
      )}
    </Box>
  );
}
